module.exports = __webpack_public_path__ + "assets/layers_blue.ce528cda.svg";